import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #46BC9A, step up 8%, step down 11%
// https://www.shadecolr.com/#colors=Y29sb3I6MTYyLjcxMTg2NDQwNjc3OTY1LDQ2LjgyNTM5NjgyNTM5NjgzLDUwLjU4ODIzNTI5NDExNzY0NXxzdGVwLXVwOjh8c3RlcC1kb3duOjExfGh1ZS1zaGlmdDowfGJhc2Utc3RvcDo1fG5hbWU6Z3JlZW58bG9ja2VkOjA%3D&active=color-1&v=2
const primary = {
  lighter: '#BEE7DB',
  light: '#82D2BB',
  main: '#46BC9A',
  dark: '#276B57',
  darker: '#091914',
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    action: {
      hover: alpha(primary.main, 0.16), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: primary.main,
      menuActiveText: '#fff',
      menuHoverBg: alpha(primary.main, 0.2),
      searchHoverBorder: primary.light,
    },
  },
};
